import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import TextField from 'material-ui/TextField'
import Checkbox from 'material-ui/Checkbox'
import Divider from 'material-ui/Divider'

import MainInfo from './MainInfo'
import AdditionalInfo from './AdditionalInfo'

export default class LeftSide extends Component{
	render(){
		let { props } = this
		return(
			<div
				key={props.ownerID}
				className="left-side"
				style={{
					 width: "50%"
   				   , overflowY: "scroll"
				   , overflowX: "hidden"
				}}
			>
				<MainInfo ownerID={props.ownerID} />
				<AdditionalInfo ownerID={props.ownerID} query={props.query}/>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/routes/landlord/profile/LeftSide.js